import React from 'react'
import { Stepper, Step, StepLabel, StepIconProps } from '@material-ui/core'
import theme from 'presentation/styles/theme'
import * as S from './styles'
import { useMedia } from 'presentation/utils/window-media'

export type WizardProps = {
  activeStep: number
  steps: string[]
  nonLinear?: boolean
  completedSteps?: number[]
  activeColor?: keyof typeof theme.ds.colors
  completedColor?: keyof typeof theme.ds.colors
  activeBackgroundColor?: keyof typeof theme.ds.colors
}

const Wizard = ({
  activeStep,
  steps,
  nonLinear = false,
  completedSteps = [],
  activeColor = 'primary600',
  completedColor = 'primary300',
  activeBackgroundColor = 'primary100'
}: WizardProps) => {
  const media = useMedia()

  const CustomStepIconWithColors = (props: StepIconProps) => {
    const { active, completed, icon } = props

    return (
      <S.StepIconRoot
        className={`${active ? 'active' : ''} ${completed ? 'completed' : ''}`}
        activeColor={activeColor}
        completedColor={completedColor}
      >
        <S.StepIconText>{icon}</S.StepIconText>
      </S.StepIconRoot>
    )
  }

  return (
    <S.Wrapper
      activeColor={activeColor}
      completedColor={completedColor}
      activeBackgroundColor={activeBackgroundColor}
    >
      <Stepper activeStep={activeStep} nonLinear={nonLinear}>
        {steps.map((label, index) => (
          <Step key={label} completed={completedSteps.includes(index)}>
            <StepLabel StepIconComponent={CustomStepIconWithColors}>
              {media.md && label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </S.Wrapper>
  )
}

export default Wizard
